import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-18e0a23a")

_pushScopeId("data-v-18e0a23a")
const _hoisted_1 = { class: "visit-record" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h5", { style: {"margin-right":"10px"} }, [
  /*#__PURE__*/_createVNode("i", { class: "el-icon-document" }),
  /*#__PURE__*/_createTextVNode(" 测试记录 ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("全部清空")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("导出数据")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除勾选数据")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  class: "spacName",
  style: {"display":"flex","justify-content":"flex-end"}
}
const _hoisted_9 = { class: "dialogForm" }
const _hoisted_10 = { class: "dialogTitle" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "上传性能数据", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "el-icon-upload" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" 将文件拖到此处，或 "),
  /*#__PURE__*/_createVNode("em", null, "点击上传")
], -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "el-upload__tip" }, " 只能上传excel文件，且不超过50MB ", -1)
const _hoisted_15 = { class: "dialog-footer" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("重 置")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("确 定")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option_group = _resolveComponent("el-option-group")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_progress = _resolveComponent("el-progress")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode(_component_el_card, { style: {"width":"1700px","margin":"0 auto"} }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createVNode("span", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submitUpload('open'))),
                      style: {"font-size":"14px","color":"#409eff","widht":"100%","cursor":"pointer"}
                    }, "上传性能数据"),
                    _createVNode(_component_el_divider),
                    _createVNode(_component_el_card, { class: "spacName" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form, {
                          class: "spacForm",
                          size: "mini",
                          inline: true
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "选择项目" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.form.project,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.project = $event)),
                                  placeholder: "请选择项目",
                                  clearable: "",
                                  filterable: "",
                                  onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectTableChange('project')))
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.projectList, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.project_name,
                                        label: item.project__project_name,
                                        value: item.project_name
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "选择标签" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.form.label,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.label = $event)),
                                  placeholder: "请选择标签",
                                  clearable: "",
                                  filterable: "",
                                  "collapse-tags": "",
                                  "collapse-tags-tooltip": "",
                                  multiple: "",
                                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectTableChange('Search')))
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_option_group, null, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tagList, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.label_name,
                                            label: item.label_name,
                                            value: item.label_name
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "选择机型" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.form.model,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.model = $event)),
                                  placeholder: "请选择机型",
                                  clearable: "",
                                  filterable: "",
                                  "collapse-tags": "",
                                  "collapse-tags-tooltip": "",
                                  multiple: "",
                                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectTableChange('Search')))
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modelList, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.model,
                                        label: item.chinese,
                                        value: item.model
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "选择档位" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.form.level,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.level = $event)),
                                  placeholder: "请选择档位",
                                  clearable: "",
                                  onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectTableChange('Search')))
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.levelList, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.level,
                                        label: item.chinese,
                                        value: item.level
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "选择测试人员" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.form.tester,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.tester = $event)),
                                  placeholder: "请选择测试人员",
                                  clearable: "",
                                  onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectTableChange('Search')))
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.testerList, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.tester,
                                        label: item.tester,
                                        value: item.tester
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onTableClear()))
                                }, {
                                  default: _withId(() => [
                                    _hoisted_3
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _ctx.downloadCsv
                                }, {
                                  default: _withId(() => [
                                    _hoisted_4
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _ctx.deleteData
                                }, {
                                  default: _withId(() => [
                                    _hoisted_5
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_el_table, {
                          onSelectionChange: _ctx.handleCheck,
                          data: _ctx.get_all_performance,
                          ref: "dataTable",
                          "header-cell-class-name": "tabelHeader"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              index: _ctx.indexMethod(0),
                              type: "index",
                              label: "序号",
                              width: "60"
                            }, null, 8, ["index"]),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PerfFields, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_table_column, {
                                key: item.label,
                                index: index,
                                width: item.width,
                                label: item.label,
                                prop: item.prop,
                                title: item.prop,
                                "show-overflow-tooltip": true
                              }, {
                                default: _withId((scope) => [
                                  _createTextVNode(_toDisplayString(scope.row[item.prop] ? scope.row[item.prop] : "-"), 1)
                                ]),
                                _: 2
                              }, 1032, ["index", "width", "label", "prop", "title"]))
                            }), 128)),
                            _createVNode(_component_el_table_column, {
                              "label-class-name": "DisabledSelection",
                              type: "selection",
                              label: "有效",
                              width: "60",
                              fixed: "right"
                            }, {
                              default: _withId((scope) => [
                                _createVNode(_component_el_checkbox, {
                                  modelValue: scope.row.is_check,
                                  "onUpdate:modelValue": ($event: any) => (scope.row.is_check = $event),
                                  onChange: ($event: any) => (_ctx.checkChange(scope.row))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "详情",
                              width: "60",
                              fixed: "right"
                            }, {
                              default: _withId((scope) => [
                                (scope.row.url)
                                  ? (_openBlock(), _createBlock(_component_el_link, {
                                      key: 0,
                                      href: scope.row.url,
                                      type: "primary",
                                      target: "_blank"
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_6
                                      ]),
                                      _: 2
                                    }, 1032, ["href"]))
                                  : (_openBlock(), _createBlock("span", _hoisted_7, "-"))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["onSelectionChange", "data"]), [
                          [_directive_loading, _ctx.loading]
                        ]),
                        _createVNode("div", _hoisted_8, [
                          _createVNode(_component_el_form, {
                            inline: true,
                            size: "mini",
                            style: {"display":"flex","align-items":"center"}
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "每页" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.record,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.record = $event)),
                                    style: {"width":"50px"},
                                    onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectTableChange('paging')))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "条记录" }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_pagination, {
                                    onCurrentChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.selectTableChange('paging'))),
                                    currentPage: _ctx.current_page,
                                    "onUpdate:currentPage": _cache[16] || (_cache[16] = ($event: any) => (_ctx.current_page = $event)),
                                    "page-size": _ctx.record,
                                    layout: "total, prev, pager, next, jumper",
                                    total: _ctx.readPerformancePageList.count
                                  }, null, 8, ["currentPage", "page-size", "total"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode("div", _hoisted_9, [
                          _createVNode(_component_el_dialog, {
                            modelValue: _ctx.dialogVisible,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.dialogVisible = $event)),
                            width: "30%",
                            onClose: _cache[22] || (_cache[22] = ($event: any) => (_ctx.dialogVisible = false))
                          }, {
                            title: _withId(() => [
                              _createVNode("div", _hoisted_10, [
                                _hoisted_11,
                                _createVNode(_component_el_divider)
                              ])
                            ]),
                            footer: _withId(() => [
                              _createVNode("span", _hoisted_15, [
                                _createVNode(_component_el_button, {
                                  size: "small",
                                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.submitUpload('no')))
                                }, {
                                  default: _withId(() => [
                                    _hoisted_16
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_button, {
                                  size: "small",
                                  type: "primary",
                                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.submitUpload('ok')))
                                }, {
                                  default: _withId(() => [
                                    _hoisted_17
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            default: _withId(() => [
                              _createVNode(_component_el_form, {
                                model: _ctx.dialogForm,
                                size: "small",
                                "label-position": "top"
                              }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_form_item, { label: "项目" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_input, {
                                        style: {"width":"150px"},
                                        modelValue: _ctx.dialogForm1.project,
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.dialogForm1.project = $event)),
                                        placeholder: "请输入"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, { label: "PerfDog链接" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.dialogForm1.url,
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.dialogForm1.url = $event)),
                                        placeholder: "请输入"
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, { label: "上传文件" }, {
                                    default: _withId(() => [
                                      _createVNode(_component_el_upload, {
                                        class: "upload-demo",
                                        drag: "",
                                        action: "http://127.0.0.1:8081/api/v1/performance/top_perdog_upload/",
                                        multiple: "",
                                        limit: 10,
                                        "before-upload": _ctx.beforeUpload,
                                        ref: 'upload',
                                        "http-request": _ctx.UploadFile,
                                        "file-list": _ctx.fileList1
                                      }, {
                                        tip: _withId(() => [
                                          _hoisted_14
                                        ]),
                                        default: _withId(() => [
                                          _hoisted_12,
                                          _hoisted_13
                                        ]),
                                        _: 1
                                      }, 8, ["before-upload", "http-request", "file-list"]),
                                      (_ctx.progressFlag)
                                        ? (_openBlock(), _createBlock(_component_el_progress, {
                                            key: 0,
                                            percentage: _ctx.loadProgress
                                          }, null, 8, ["percentage"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["model"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})